<template>

<app-input-wrapper :value="value" :note="note" :errored="errored" :label="label">

	<input :type="type" :value="value" :placeholder="placeholder" v-on:input="onValueChange($event.target.value)" />

	<app-icon name="eye" v-if="type === 'password'" class="input-toggle" v-tooltip="'View password'" v-on:click.native="onToggleClick" />
	<app-icon name="eye-slash" v-if="type === 'text'" class="input-toggle" v-tooltip="'Hide password'" v-on:click.native="onToggleClick" />

</app-input-wrapper>

</template>

<script>

import mixinInput from '@/mixin/input.js'

export default {

	mixins: [mixinInput],

	data: function() {

		return {
			type: 'password'
		}

	},

	methods: {

		onToggleClick: function() {

			this.type = (this.type === 'password') ? 'text' : 'password'

		}

	}

}

</script>

<style scoped>

.input {
	width: 100%;
}

.input input {
	border: 1px solid var(--color-grey-light);
	height: 40px;
	border-radius: 4px 0px 0px 4px;
	transition: all 100ms linear;
	width: 100%;
	font-size: 14px;
	color: var(--color-grey-dark);
	padding: 0px 10px;
}

.input-toggle {
	width: 40px;
	height: 40px;
	text-align: center;
	line-height: 40px;
	background-color: var(--color-blue-light);
	cursor: pointer;
	color: #fff;
	font-size: 16px;
	transition: all 100ms linear;
	border-radius: 0px 4px 4px 0px;
}

.input >>> .input-content-input {
	flex-direction: row!important;
	flex-wrap: nowrap!important;
}

.is-desktop .input-toggle:hover {
	background-color: var(--color-blue-dark);
}

.input.is-errored input {
	border-color: var(--color-red-light);
}

.is-desktop .input:hover input {
	border-color: var(--color-grey-highlight);
}

.is-desktop .input.is-errored:hover input {
	border-color: var(--color-red-light);
}

.input input::placeholder {
	color: var(--color-grey);
}

</style>